(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["add-ons"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGxtra(root) {
    if (root.dataset.gxtraReady) return;
    root.dataset.gxtraReady = '1';

    var productTitle = root.dataset.productTitle || '';
    var redirectToCart = root.dataset.redirect === 'true';
    var moveInline = root.dataset.inline === 'true';
    var moneyFmt = function (n) {
      return n.toFixed(2).replace('.', ',') + ' €';
    };

    var checks = Array.prototype.slice.call(root.querySelectorAll('.gxtra-check'));
    var totalEl = root.querySelector('[data-gx-total]');
    var totalVal = root.querySelector('[data-gx-total-value]');

    /* Das Produktformular des Themes finden (das mit [name="id"]) */
    var productForm = null;
    Array.prototype.some.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      if (f.querySelector('[name="id"]')) { productForm = f; return true; }
    });

    /* ── Karte direkt unter den Kaufen-Button hängen ──
       Bevorzugt hinter den Buy-Buttons-Block, sonst hinter
       das Formular. Fallback: bleibt, wo die Section liegt. */
    if (moveInline && productForm) {
      var anchor =
        productForm.querySelector('.product-form__buy-buttons, .buy-buttons, [class*="buy-buttons"]') ||
        productForm;
      var target = anchor === productForm ? productForm : anchor;
      try {
        target.insertAdjacentElement('afterend', root);
      } catch (e) {
        /* Position beibehalten */
      }
    }

    function track(evt, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: evt }, payload));
    }

    function updateTotal() {
      var sum = 0;
      checks.forEach(function (c) {
        if (c.checked) sum += +c.dataset.price;
      });
      if (sum > 0) {
        totalEl.hidden = false;
        totalVal.textContent = '+ ' + moneyFmt(sum);
      } else {
        totalEl.hidden = true;
      }
    }

    checks.forEach(function (c) {
      c.addEventListener('change', function () {
        updateTotal();
        track('gift_addon_toggle', {
          gift_addon: c.dataset.gxAddon,
          gift_addon_checked: c.checked,
          gift_addon_product: productTitle
        });
      });
    });

    function selectedAddonItems() {
      var items = [];
      checks.forEach(function (c) {
        if (!c.checked) return;
        items.push({
          id: +c.dataset.variant,
          quantity: 1,
          properties: { 'Gehört zu': productTitle }
        });
      });
      return items;
    }

    /* ── Submit abfangen — NUR wenn Extras gewählt sind ── */
    if (productForm) {
      document.addEventListener('submit', function (e) {
        if (e.target !== productForm) return;
        var addons = selectedAddonItems();
        if (!addons.length) return; // Theme-Verhalten unangetastet

        /* Native Validierung (z. B. Pflichtfelder der
           Personalisierungs-App) respektieren */
        if (typeof productForm.checkValidity === 'function' && !productForm.checkValidity()) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        /* Hauptprodukt 1:1 aus dem Theme-Formular übernehmen —
           inkl. Menge, Variante und ALLER Properties */
        var fd = new FormData(productForm);
        var main = {
          id: +fd.get('id'),
          quantity: +(fd.get('quantity') || 1),
          properties: {}
        };
        fd.forEach(function (v, k) {
          var m = k.match(/^properties\[(.+)\]$/);
          if (m && v && typeof v === 'string') main.properties[m[1]] = v;
        });
        if (fd.get('selling_plan')) main.selling_plan = +fd.get('selling_plan');

        var submitBtn = productForm.querySelector('[type="submit"]');
        var btnHtml = submitBtn ? submitBtn.innerHTML : null;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Wird hinzugefügt…';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [main].concat(addons) })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw j; });
            return r.json();
          })
          .then(function () {
            var addonValue = 0;
            checks.forEach(function (c) {
              if (c.checked) addonValue += +c.dataset.price;
            });
            track('gift_addons_added', {
              gift_addon_count: addons.length,
              gift_addon_value: Math.round(addonValue * 100) / 100,
              gift_addon_product: productTitle
            });

            if (redirectToCart) {
              window.location.href = '/cart';
              return;
            }
            /* Prestige/Maestrooo: Drawer aktualisieren & öffnen */
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
            );
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = btnHtml;
            }
          })
          .catch(function (err) {
            console.warn('[gxtra] Add-to-cart fehlgeschlagen, Fallback:', err);
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = btnHtml;
            }
            window.location.href = '/cart';
          });
      }, true); /* capture: läuft vor dem Theme-Handler */
    }

    updateTotal();
  }

  function initAll() {
    document.querySelectorAll('.gxtra').forEach(initGxtra);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anlass-navigation"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGmega(root) {
    if (root.dataset.gmegaReady) return;
    root.dataset.gmegaReady = '1';

    var hoverEnabled = root.dataset.hover === 'true';
    var mq = window.matchMedia('(max-width: 640px)');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.gmega-trigger'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.gmega-panel'));
    var panelHome = root.querySelector('.gmega-panels');
    var burger = root.querySelector('.gmega-burger');
    var closeTimer = null;

    var panelByName = {};
    panels.forEach(function (p) { panelByName[p.dataset.panel] = p; });

    function isMobile() { return mq.matches; }

    function setExpanded(name) {
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t.dataset.target === name ? 'true' : 'false');
      });
    }

    function closeAllPanels() {
      panels.forEach(function (p) {
        p.classList.remove('is-open');
        if (!isMobile()) {
          // Fade-out abwarten, dann verstecken (Desktop-Overlay)
          window.setTimeout(function () {
            if (!p.classList.contains('is-open')) p.hidden = true;
          }, 220);
        }
      });
      setExpanded(null);
    }

    function openDesktopPanel(name) {
      window.clearTimeout(closeTimer);
      closeSearch(); // offene Suche schließen, wenn ein Panel aufgeht
      panels.forEach(function (p) {
        if (p.dataset.panel === name) {
          p.hidden = false;
          void p.offsetWidth; // reflow, damit die Transition greift
          p.classList.add('is-open');
        } else {
          p.classList.remove('is-open');
          p.hidden = true;
        }
      });
      setExpanded(name);
    }

    function toggleAccordion(name) {
      var panel = panelByName[name];
      if (!panel) return;
      var wasOpen = panel.classList.contains('is-open');
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      if (wasOpen) {
        setExpanded(null);
      } else {
        panel.classList.add('is-open');
        setExpanded(name);
      }
    }

    function openMobileNav() {
      closeSearch(); // Suche & Menü nicht gleichzeitig
      root.classList.add('gmega--nav-open');
      if (burger) {
        burger.setAttribute('aria-expanded', 'true');
        burger.setAttribute('aria-label', 'Menü schließen');
      }
    }

    function closeMobileNav() {
      root.classList.remove('gmega--nav-open');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Menü öffnen');
      }
    }

    // Mobil: Panels als Accordion direkt hinter ihren Trigger verschieben
    function enterMobile() {
      triggers.forEach(function (t) {
        var p = panelByName[t.dataset.target];
        if (p) {
          t.insertAdjacentElement('afterend', p);
          p.hidden = false;          // Sichtbarkeit steuert grid-template-rows
          p.classList.remove('is-open');
        }
      });
      setExpanded(null);
    }

    // Desktop: Panels zurück in den Overlay-Container
    function enterDesktop() {
      closeMobileNav();
      panels.forEach(function (p) {
        panelHome.appendChild(p);
        p.classList.remove('is-open');
        p.hidden = true;
      });
      setExpanded(null);
    }

    function scheduleClose() {
      closeTimer = window.setTimeout(closeAllPanels, 160);
    }

    /* ══════════ Produktsuche (Predictive Search) ══════════ */
    var searchToggle = root.querySelector('.gmega-search-toggle');
    var searchInput = root.querySelector('.gmega-search-input');
    var searchResults = root.querySelector('.gmega-search-results');
    var searchLimit = parseInt(root.dataset.searchLimit, 10) || 6;
    var searchUrl = root.dataset.searchUrl || '/search';
    var currency = root.dataset.currency || 'EUR';
    var searchTimer = null;
    var searchController = null;
    var priceFormatter;
    try {
      priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });
    } catch (e) {
      priceFormatter = null;
    }

    function formatPrice(value) {
      var num = parseFloat(value);
      if (isNaN(num)) return '';
      return priceFormatter ? priceFormatter.format(num) : num.toFixed(2).replace('.', ',') + ' €';
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function thumbUrl(url) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
    }

    function isSearchOpen() {
      return root.classList.contains('gmega--search-open');
    }

    function openSearch() {
      closeAllPanels();
      closeMobileNav();
      root.classList.add('gmega--search-open');
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', 'true');
        searchToggle.setAttribute('aria-label', 'Suche schließen');
      }
      // Fokus erst nach der Aufgleit-Animation, sonst springt das Layout
      window.setTimeout(function () {
        if (searchInput && isSearchOpen()) searchInput.focus();
      }, 200);
    }

    function closeSearch() {
      if (!isSearchOpen()) return;
      root.classList.remove('gmega--search-open');
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.setAttribute('aria-label', 'Suche öffnen');
      }
      if (searchController) searchController.abort();
      window.clearTimeout(searchTimer);
    }

    function renderHint(text) {
      searchResults.innerHTML = '<p class="gmega-search-hint">' + escapeHtml(text) + '</p>';
    }

    function renderResults(products, query) {
      if (!products.length) {
        renderHint('Keine Produkte gefunden für „' + query + '“.');
        return;
      }
      var html = '<ul class="gmega-search-list">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        html += '<li class="gmega-search-item">' +
          '<a href="' + escapeHtml(p.url) + '">' +
          (img
            ? '<img class="gmega-search-thumb" src="' + escapeHtml(thumbUrl(img)) + '" alt="" width="48" height="48" loading="lazy" decoding="async">'
            : '<span class="gmega-search-thumb" aria-hidden="true"></span>') +
          '<span class="gmega-search-item-title">' + escapeHtml(p.title) + '</span>' +
          '<span class="gmega-search-item-price">' + formatPrice(p.price) + '</span>' +
          '</a></li>';
      });
      html += '</ul>';
      html += '<a class="gmega-search-all" href="' + escapeHtml(searchUrl) + '?q=' + encodeURIComponent(query) + '&type=product">' +
        'Alle Ergebnisse anzeigen' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><line x1="4" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg>' +
        '</a>';
      searchResults.innerHTML = html;
    }

    function runSearch(query) {
      if (searchController) searchController.abort();
      searchController = ('AbortController' in window) ? new AbortController() : null;
      renderHint('Suche läuft …');

      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' + searchLimit +
        '&resources[options][unavailable_products]=last';

      fetch(endpoint, searchController ? { signal: searchController.signal } : undefined)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          renderHint('Suche gerade nicht verfügbar — Enter drücken für die Suchseite.');
        });
    }

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        var q = searchInput.value.trim();
        window.clearTimeout(searchTimer);
        if (q.length < 2) {
          searchResults.innerHTML = '';
          if (searchController) searchController.abort();
          return;
        }
        searchTimer = window.setTimeout(function () { runSearch(q); }, 250);
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        if (isSearchOpen()) { closeSearch(); } else { openSearch(); }
      });
    }
    /* ══════════ Ende Produktsuche ══════════ */

    /* ══════════ Warenkorb-Zähler live halten ══════════ */
    var cartCountEl = root.querySelector('[data-cart-count]');
    var cartLink = root.querySelector('.gmega-cart');
    var cartFetchTimer = null;

    function setCartCount(count) {
      if (!cartCountEl) return;
      count = parseInt(count, 10) || 0;
      var changed = cartCountEl.textContent !== String(count);
      cartCountEl.textContent = count;
      cartCountEl.classList.toggle('is-empty', count === 0);
      if (cartLink) {
        cartLink.setAttribute('aria-label', count > 0
          ? 'Warenkorb ansehen (' + count + ' Artikel)'
          : 'Warenkorb ansehen');
      }
      if (changed && count > 0) {
        cartCountEl.classList.add('is-bump');
        window.setTimeout(function () { cartCountEl.classList.remove('is-bump'); }, 300);
      }
    }

    function refreshCartCount() {
      // leicht entprellt, falls mehrere Events kurz nacheinander feuern
      window.clearTimeout(cartFetchTimer);
      cartFetchTimer = window.setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { setCartCount(cart.item_count); })
          .catch(function () { /* still: Liquid-Wert bleibt stehen */ });
      }, 150);
    }

    // Prestige & gängige Themes feuern eigene Events nach Add-to-Cart;
    // wir lauschen breit und holen den Stand sicherheitshalber via /cart.js
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'variant:added', 'product:added']
      .forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          if (e.detail && e.detail.cart && typeof e.detail.cart.item_count !== 'undefined') {
            setCartCount(e.detail.cart.item_count);
          } else {
            refreshCartCount();
          }
        });
      });

    // Zurück-Navigation aus dem bfcache (Safari/iOS): Stand auffrischen
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCartCount();
    });
    /* ══════════ Ende Warenkorb-Zähler ══════════ */

    triggers.forEach(function (trigger) {
      var name = trigger.dataset.target;

      trigger.addEventListener('click', function () {
        if (isMobile()) {
          toggleAccordion(name);
          return;
        }
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) { closeAllPanels(); } else { openDesktopPanel(name); }
      });

      if (hoverEnabled) {
        trigger.addEventListener('mouseenter', function () { if (!isMobile()) openDesktopPanel(name); });
        trigger.addEventListener('mouseleave', function () { if (!isMobile()) scheduleClose(); });
        trigger.addEventListener('focus', function () { if (!isMobile()) openDesktopPanel(name); });
      }
    });

    if (hoverEnabled) {
      panels.forEach(function (p) {
        p.addEventListener('mouseenter', function () { if (!isMobile()) window.clearTimeout(closeTimer); });
        p.addEventListener('mouseleave', function () { if (!isMobile()) scheduleClose(); });
      });
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (root.classList.contains('gmega--nav-open')) {
          closeMobileNav();
          closeAllPanels();
        } else {
          openMobileNav();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllPanels();
        closeMobileNav();
        closeSearch();
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closeAllPanels();
        closeMobileNav();
        closeSearch();
      }
    });

    // Breakpoint-Wechsel sauber behandeln (Rotation, Resize, Editor)
    var onBreakpointChange = function (e) {
      if (e.matches) { enterMobile(); } else { enterDesktop(); }
    };
    if (mq.addEventListener) { mq.addEventListener('change', onBreakpointChange); }
    else { mq.addListener(onBreakpointChange); }

    if (mq.matches) { enterMobile(); }
  }

  function initAll() {
    document.querySelectorAll('.gmega').forEach(initGmega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init inside the theme editor when the section is added/changed
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produktfinder"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ─────────────────────────────────────────────────────────
     Kuratierter Katalog: Matching-Attribute & Kurztexte.
     Schlüssel = Shopify-Handle (muss zur Liquid-Liste passen).
     anlass/sleep = Gewichte (höher = relevanter), expecting =
     Gewicht für den "Wir erwarten ein Baby"-Pfad.
     ───────────────────────────────────────────────────────── */
  var GF_META = {
    'kuschelschaf-musselin': {
      label: 'Kuschelschaf', emoji: '🐑', best: true, perso: true,
      char: 'schaf', size: 'std',
      blurb: 'Der Bestseller – handgemacht, waschbar und mit Merinowolle gefüllt.',
      anlass: { geburt: 3, taufe: 3, geburtstag: 3, geschwister: 2, einfachso: 3 },
      sleep: { baby: 3, kind: 2 }, expecting: 3
    },
    'kuschelhase': {
      label: 'Kuschelhase', emoji: '🐰', perso: true,
      char: 'hase', size: 'std',
      blurb: 'Weicher Begleiter mit Schlappohren – zum Liebhaben und Einschlafen.',
      anlass: { geburt: 2, taufe: 2, geburtstag: 2, geschwister: 2, einfachso: 2 },
      sleep: { baby: 2, kind: 2 }, expecting: 2
    },
    'kuschelhund-musselin': {
      label: 'Kuschelhund', emoji: '🐶', perso: true,
      char: 'hund', size: 'std',
      blurb: 'Der treue Freund fürs Kinderzimmer – aus weichem Musselin.',
      anlass: { geburt: 2, taufe: 2, geburtstag: 2, geschwister: 2, einfachso: 2 },
      sleep: { baby: 2, kind: 2 }, expecting: 2
    },
    'kuschelpferd-musselin': {
      label: 'Kuschelpferd', emoji: '🐴', perso: true,
      char: 'pferd', size: 'std',
      blurb: 'Für kleine Pferdefreunde – weich gefüllt mit Merinowolle.',
      anlass: { geburtstag: 3, geschwister: 2, einfachso: 2 },
      sleep: { kind: 2 }
    },
    'kuschelschaf-xxl-1': {
      label: 'Kuschelschaf XXL', emoji: '🐑', perso: true,
      char: 'schaf', size: 'xxl',
      blurb: 'Das Schaf im Großformat – Kissen und Kuschelfreund in einem.',
      anlass: { geburtstag: 2, einfachso: 2 },
      sleep: { kind: 2 }
    },
    'kuschelhund-xxl': {
      label: 'Kuschelhund XXL', emoji: '🐶', perso: true,
      char: 'hund', size: 'xxl',
      blurb: 'Der große Freund zum Anlehnen, Kuscheln und Träumen.',
      anlass: { geburtstag: 2, einfachso: 2 },
      sleep: { kind: 2 }
    },
    'geburtsgeschenk-bundle-⭐': {
      label: 'Geburtsgeschenk Bundle',
      blurb: 'Alles fürs Willkommen: Kuschelschaf plus liebevolle Extras.',
      anlass: { geburt: 4, taufe: 2 }, expecting: 3
    },
    'gute-nacht-bundle-⭐': {
      label: 'Gute Nacht Bundle',
      blurb: 'Kuscheltier & Co. für ein festes, liebevolles Abendritual.',
      anlass: { geburt: 2, geburtstag: 2, einfachso: 2 },
      sleep: { baby: 3, kind: 3 }
    },
    'einschlaf-bundle': {
      label: 'Einschlafritual Bundle',
      blurb: 'Das komplette Einschlafritual – Kuschelschaf, Buch und mehr.',
      anlass: { geburtstag: 2 },
      sleep: { kind: 4, baby: 2 }
    },
    'premium-geschenk-set-⭐': {
      label: 'Premium Geschenk Set',
      blurb: 'Das große Set für den ganz besonderen Anlass.',
      anlass: { taufe: 4, geburt: 3 }, expecting: 2
    },
    'geschwister-set': {
      label: 'Geschwister Set',
      blurb: 'Zwei Kuschelfreunde – damit niemand zu kurz kommt.',
      anlass: { geschwister: 5 }
    },
    'schlaf-gut-kleines-schafchen-ein-buch-fur-geborgene-momente-⭐': {
      label: 'Buch „Schlaf gut, kleines Schäfchen“',
      blurb: 'Die Gute-Nacht-Geschichte zum Kuschelschaf.',
      anlass: { geburt: 1, taufe: 1, geburtstag: 1, geschwister: 2, einfachso: 2 },
      sleep: { baby: 2, kind: 2 }, expecting: 1, extra: true
    },
    'dinkelkissen-beige-blumen': {
      label: 'Dinkelkissen',
      blurb: 'Wohlige Wärme für Bauch, Nacken und kalte Abende.',
      anlass: { einfachso: 1 },
      sleep: { kind: 2, me: 2 }, extra: true
    },
    'dinkelkissen-set': {
      label: 'Dinkelkissen Set',
      blurb: 'Wärmekissen im Set – zum Teilen oder Vorrätighaben.',
      anlass: { einfachso: 2 },
      sleep: { kind: 2, me: 2 }
    },
    'kissen-30x30': {
      label: 'Merino Kissen 30×30 cm',
      blurb: 'Merinowolle gleicht die Temperatur aus – für erholsamen Kinderschlaf.',
      sleep: { kind: 3 }
    },
    'kissen-60x40': {
      label: 'Merino Kissen 60×40 cm',
      blurb: 'Natürlich temperaturausgleichend – für tiefen, ruhigen Schlaf.',
      sleep: { me: 4 }
    },
    'babyschlafsack-gefullt-mit-100-merinowolle': {
      label: 'Babyschlafsack',
      blurb: '100 % Merinowolle – hält warm, ohne zu überhitzen.',
      anlass: { geburt: 2 },
      sleep: { baby: 4 }, expecting: 4
    },
    'kinder-tasche-als-rucksack-oder-crossbody': {
      label: 'Kinder-Tasche',
      blurb: 'Rucksack und Crossbody in einem – für kleine Entdecker.',
      anlass: { geburtstag: 2, geschwister: 2 }
    },
    'kuschelsocken-damen-37-41': {
      label: 'Merino-Wollsocken',
      blurb: 'Merinowolle für warme Füße – auch als Pärchen-Set.',
      anlass: { einfachso: 2 },
      sleep: { me: 2 }, extra: true
    },
    'die-grafin-geschenk-gutschein': {
      label: 'Geschenk-Gutschein',
      blurb: 'Wenn die Wahl schwerfällt – so suchen sie selbst aus.',
      anlass: { einfachso: 2, geburtstag: 1 },
      fromPrice: true, fallback: true
    },
    '__bettwaesche': {
      label: 'Premium-Bettwäsche',
      blurb: 'Viele liebevolle Designs für Groß und Klein.',
      sleep: { kind: 3, me: 3 }
    }
  };

  /* ── Fragen ── */
  var GF_QUESTIONS = {
    goal: {
      label: 'Wobei dürfen wir dir helfen?',
      options: [
        { v: 'gift',      e: '🎁', t: 'Ich suche ein Geschenk' },
        { v: 'plush',     e: '🐑', t: 'Einen Kuschelfreund finden' },
        { v: 'sleep',     e: '🌙', t: 'Besser schlafen' },
        { v: 'expecting', e: '🤍', t: 'Wir erwarten ein Baby' }
      ]
    },
    occasion: {
      label: 'Was ist der Anlass?',
      options: [
        { v: 'geburt',     e: '👶', t: 'Zur Geburt' },
        { v: 'taufe',      e: '✨', t: 'Zur Taufe' },
        { v: 'geburtstag', e: '🎂', t: 'Zum Geburtstag' },
        { v: 'geschwister',e: '🧸', t: 'Fürs Geschwisterkind' },
        { v: 'einfachso',  e: '💛', t: 'Einfach eine Freude machen' }
      ]
    },
    character: {
      label: 'Wer soll der neue Freund werden?',
      options: [
        { v: 'schaf',    e: '🐑', t: 'Das Schaf', h: 'Unser Klassiker' },
        { v: 'hase',     e: '🐰', t: 'Der Hase' },
        { v: 'hund',     e: '🐶', t: 'Der Hund' },
        { v: 'pferd',    e: '🐴', t: 'Das Pferd' },
        { v: 'surprise', e: '✨', t: 'Überrasch mich' }
      ]
    },
    psize: {
      label: 'Welche Größe darf es sein?',
      options: [
        { v: 'std',  e: '🤏', t: 'Klassisch', h: 'ca. 30 cm – ideal für kleine Arme' },
        { v: 'xxl',  e: '🫶', t: 'XXL', h: 'Kissen und Kuschelfreund in einem' },
        { v: 'both', e: '👀', t: 'Zeig mir beides' }
      ]
    },
    sleepwho: {
      label: 'Für wen soll der Schlaf besser werden?',
      options: [
        { v: 'baby', e: '👶', t: 'Für unser Baby' },
        { v: 'kind', e: '🧒', t: 'Für mein Kind' },
        { v: 'me',   e: '🌙', t: 'Für mich' }
      ]
    },
    budget: {
      label: 'Wie viel möchtest du ungefähr ausgeben?',
      options: [
        { v: '30',  e: '💛', t: 'Bis 30 €' },
        { v: '75',  e: '💛', t: 'Bis 75 €' },
        { v: '110', e: '💛', t: 'Bis 110 €' },
        { v: 'inf', e: '💛', t: 'Nach oben offen' }
      ]
    }
  };

  var GF_TIPS = {
    gift:      '💡 Tipp: Alle Kuscheltiere lassen sich mit Namen besticken – so wird\u2019s ein Unikat.',
    plush:     '💡 Tipp: Jeder Kuschelfreund lässt sich mit Namen personalisieren.',
    expecting: '💡 Tipp: Mit Namen bestickt wird das Kuschelschaf zum ersten ganz eigenen Schatz.'
  };

  function gfFlow(answers) {
    switch (answers.goal) {
      case 'gift':  return ['goal', 'occasion', 'budget'];
      case 'plush':
        var f = ['goal', 'character'];
        // Größenfrage nur, wenn es den Charakter auch in XXL gibt
        if (answers.character === 'schaf' || answers.character === 'hund') f.push('psize');
        return f;
      case 'sleep': return ['goal', 'sleepwho', 'budget'];
      case 'expecting': return ['goal', 'budget'];
      default: return ['goal'];
    }
  }

  function initGfind(root) {
    if (root.dataset.gfindReady) return;
    root.dataset.gfindReady = '1';

    var sectionId = root.id.replace('gfind-', '');
    var dataEl = document.querySelector('[data-gfind-data="' + sectionId + '"]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Katalog: Meta + Live-Daten mergen, Nicht-Verfügbares raus
    var catalog = [];
    Object.keys(GF_META).forEach(function (handle) {
      var live = data.products[handle];
      if (!live || !live.ok || live.available === false) return;
      var item = Object.assign({ handle: handle }, GF_META[handle], live);
      catalog.push(item);
    });

    var stage = root.querySelector('[data-gfind-stage]');
    var foot = root.querySelector('[data-gfind-foot]');
    var backBtn = root.querySelector('[data-gfind-back]');
    var restartBtn = root.querySelector('[data-gfind-restart]');
    var progLabel = root.querySelector('[data-gfind-progress-label]');
    var progFill = root.querySelector('[data-gfind-progress-fill]');
    var progWrap = root.querySelector('[data-gfind-progress]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var answers = {};
    var history = [];

    function track(evt, payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: evt }, payload));
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function swap(html, done) {
      if (reduceMotion) {
        stage.innerHTML = html;
        if (done) done();
        return;
      }
      stage.classList.add('is-leaving');
      window.setTimeout(function () {
        stage.innerHTML = html;
        stage.classList.remove('is-leaving');
        if (done) done();
      }, 200);
    }

    function updateProgress(stepIndex, total, isResult) {
      if (isResult) {
        progWrap.style.display = 'none';
        return;
      }
      progWrap.style.display = '';
      progLabel.textContent = 'Frage ' + (stepIndex + 1) + ' von ' + total;
      progFill.style.width = (stepIndex / total * 100) + '%';
    }

    function updateFoot(isStart, isResult) {
      foot.hidden = isStart;
      backBtn.hidden = isStart;
      restartBtn.hidden = isStart || !isResult;
    }

    /* ── Frage rendern ── */
    function renderQuestion(qkey) {
      var q = GF_QUESTIONS[qkey];
      var flow = gfFlow(answers);
      var idx = flow.indexOf(qkey);
      var total = Math.max(flow.length, answers.goal ? flow.length : 3);

      var html = '<p class="gfind-q-label">' + esc(q.label) + '</p><ul class="gfind-options">';
      q.options.forEach(function (o) {
        html += '<li><button type="button" class="gfind-opt" data-q="' + esc(qkey) + '" data-v="' + esc(o.v) + '">' +
          '<span class="gfind-opt-emoji" aria-hidden="true">' + o.e + '</span>' +
          '<span>' + esc(o.t) + (o.h ? '<span class="gfind-opt-hint">' + esc(o.h) + '</span>' : '') + '</span>' +
          '</button></li>';
      });
      html += '</ul>';

      updateProgress(idx < 0 ? 0 : idx, total, false);
      updateFoot(history.length === 0, false);
      swap(html);
    }

    /* ── Empfehlungslogik ── */
    function budgetCap() {
      var b = answers.budget;
      if (!b || b === 'inf') return Infinity;
      return parseFloat(b);
    }

    function scoreAndPick(scoreFn, opts) {
      opts = opts || {};
      var cap = opts.ignoreBudget ? Infinity : budgetCap();
      function pick(useCap) {
        return catalog
          .map(function (p) { return { p: p, s: scoreFn(p) }; })
          .filter(function (x) {
            if (x.s <= 0) return false;
            if (useCap && x.p.price != null && !x.p.fromPrice && x.p.price > cap) return false;
            return true;
          })
          .sort(function (a, b) {
            if (b.s !== a.s) return b.s - a.s;
            if (!!b.p.best !== !!a.p.best) return (b.p.best ? 1 : 0) - (a.p.best ? 1 : 0);
            return (a.p.price || 0) - (b.p.price || 0);
          })
          .map(function (x) { return x.p; });
      }
      var res = pick(true);
      if (res.length < 3) res = pick(false); // Budget lockern, wenn zu wenig übrig
      return res;
    }

    function recommend() {
      var primary = [], extras = [], tip = null;

      if (answers.goal === 'gift') {
        var occ = answers.occasion;
        primary = scoreAndPick(function (p) { return (p.anlass && p.anlass[occ]) || 0; });
        tip = GF_TIPS.gift;
      }
      else if (answers.goal === 'plush') {
        var ch = answers.character, sz = answers.psize || 'both';
        var pool = catalog.filter(function (p) { return !!p.char; });
        if (ch !== 'surprise') pool = pool.filter(function (p) { return p.char === ch; });
        if (sz !== 'both') pool = pool.filter(function (p) { return p.size === sz; });
        pool.sort(function (a, b) {
          if (!!b.best !== !!a.best) return (b.best ? 1 : 0) - (a.best ? 1 : 0);
          return (a.price || 0) - (b.price || 0);
        });
        primary = pool;
        extras = ['schlaf-gut-kleines-schafchen-ein-buch-fur-geborgene-momente-⭐', 'gute-nacht-bundle-⭐'];
        tip = GF_TIPS.plush;
      }
      else if (answers.goal === 'sleep') {
        var who = answers.sleepwho;
        primary = scoreAndPick(function (p) { return (p.sleep && p.sleep[who]) || 0; });
      }
      else if (answers.goal === 'expecting') {
        primary = scoreAndPick(function (p) { return p.expecting || 0; });
        tip = GF_TIPS.expecting;
      }

      // Fallback, falls (z. B. durch Budget) nichts übrig bleibt
      if (!primary.length) {
        primary = catalog.filter(function (p) { return p.fallback || p.best; });
      }

      primary = primary.slice(0, 3);

      var shown = primary.map(function (p) { return p.handle; });
      var extraItems = extras
        .filter(function (h) { return shown.indexOf(h) === -1; })
        .map(function (h) { return catalog.filter(function (p) { return p.handle === h; })[0]; })
        .filter(Boolean)
        .slice(0, 2);

      return { primary: primary, extras: extraItems, tip: tip };
    }

    /* ── Ergebnisse rendern ── */
    function productCard(p) {
      var img = p.image
        ? '<img class="gfind-rimg" src="' + esc(p.image) + '" alt="' + esc(p.label || p.title) + '" width="480" height="480" loading="lazy" decoding="async">'
        : '<div class="gfind-rimg gfind-rimg--ph" aria-hidden="true">' + (p.emoji || '🎁') + '</div>';

      var badges = '';
      if (p.best || p.perso) {
        badges = '<div class="gfind-badges">' +
          (p.best ? '<span class="gfind-badge gfind-badge--best">Bestseller</span>' : '') +
          (p.perso ? '<span class="gfind-badge gfind-badge--perso">Personalisierbar</span>' : '') +
          '</div>';
      }

      var priceTxt = p.price == null
        ? esc(p.priceLabel)
        : (p.fromPrice ? 'ab ' : '') + esc(p.priceLabel);

      return '<li><a class="gfind-rcard" href="' + esc(p.url) + '">' +
        img + badges +
        '<div class="gfind-rbody">' +
          '<h4 class="gfind-rtitle">' + esc(p.label || p.title) + '</h4>' +
          '<span class="gfind-rprice">' + priceTxt + '</span>' +
          '<p class="gfind-rblurb">' + esc(p.blurb) + '</p>' +
          '<span class="gfind-rcta">Ansehen <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><line x1="4" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg></span>' +
        '</div>' +
      '</a></li>';
    }

    function renderResults() {
      var rec = recommend();

      var html = '<p class="gfind-r-label">Unsere Empfehlung für dich</p>' +
        '<p class="gfind-r-sub">Mit Liebe ausgesucht – passend zu deinen Antworten.</p>' +
        '<ul class="gfind-results">';
      rec.primary.forEach(function (p) { html += productCard(p); });
      html += '</ul>';

      if (rec.extras.length) {
        html += '<div class="gfind-extras"><p class="gfind-extras-label">Passt gut dazu</p><ul class="gfind-extras-list">';
        rec.extras.forEach(function (p) {
          html += '<li><a class="gfind-xcard" href="' + esc(p.url) + '">' +
            (p.image ? '<img class="gfind-ximg" src="' + esc(p.image) + '" alt="" width="96" height="96" loading="lazy" decoding="async">' : '') +
            '<span><span class="gfind-xtitle">' + esc(p.label || p.title) + '</span>' +
            '<span class="gfind-xprice">' + (p.fromPrice ? 'ab ' : '') + esc(p.priceLabel) + '</span></span>' +
          '</a></li>';
        });
        html += '</ul></div>';
      }

      if (rec.tip) html += '<p class="gfind-tip">' + rec.tip + '</p>';

      if (data.allLink) {
        html += '<a class="gfind-alllink" href="' + esc(data.allLink) + '">' + esc(data.allLabel || 'Alle Geschenkideen ansehen') + ' →</a>';
      }

      updateProgress(0, 1, true);
      updateFoot(false, true);
      swap(html, function () {
        track('gfinder_result', {
          gfinder_path: answers.goal,
          gfinder_answers: JSON.stringify(answers),
          gfinder_products: rec.primary.map(function (p) { return p.handle; }).join(',')
        });
      });
    }

    /* ── Ablaufsteuerung ── */
    function next() {
      var flow = gfFlow(answers);
      for (var i = 0; i < flow.length; i++) {
        if (!(flow[i] in answers)) { renderQuestion(flow[i]); return; }
      }
      renderResults();
    }

    stage.addEventListener('click', function (e) {
      var btn = e.target.closest('.gfind-opt');
      if (!btn) return;
      var q = btn.dataset.q, v = btn.dataset.v;
      answers[q] = v;
      history.push(q);
      track('gfinder_answer', { gfinder_question: q, gfinder_answer: v });
      next();
    });

    backBtn.addEventListener('click', function () {
      var last = history.pop();
      if (last) {
        delete answers[last];
        // Antworten löschen, die nach dem entfernten Schritt kamen
        var flow = gfFlow(answers);
        Object.keys(answers).forEach(function (k) {
          if (flow.indexOf(k) === -1) delete answers[k];
        });
      }
      next();
    });

    restartBtn.addEventListener('click', function () {
      answers = {};
      history = [];
      next();
    });

    if (!catalog.length) {
      // Defensive: Produkte (noch) nicht im Shop → freundlicher Fallback
      stage.innerHTML = '<p class="gfind-noscript">Gerade sind keine Empfehlungen verfügbar. ' +
        (data.allLink ? '<a href="' + esc(data.allLink) + '">Hier geht\u2019s zu allen Geschenkideen →</a>' : '') + '</p>';
      progWrap.style.display = 'none';
      return;
    }

    next();
  }

  function initAll() {
    document.querySelectorAll('.gfind').forEach(initGfind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stick-vorschau"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* Gestickte Symbole (fill = Garnfarbe) */
  var GP_SYMBOLS = {
    herz:  '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.7-10-9.2C.4 8.2 2 4.6 5.6 4.6c2.2 0 3.5 1.4 4.4 2.7.9-1.3 2.2-2.7 4.4-2.7 3.6 0 5.2 3.6 3.6 7.2C19.5 16.3 12 21 12 21z"/></svg>',
    krone: '<svg viewBox="0 0 24 24"><path d="M3 8l4 3 5-6 5 6 4-3-1.5 10h-15L3 8zm1.8 12h14.4v2H4.8v-2z"/></svg>',
    pfote: '<svg viewBox="0 0 24 24"><ellipse cx="7" cy="7.5" rx="2" ry="2.6"/><ellipse cx="12" cy="5.8" rx="2" ry="2.6"/><ellipse cx="17" cy="7.5" rx="2" ry="2.6"/><path d="M12 10.5c3.4 0 6.5 2.7 6.5 5.6 0 2-1.5 3.4-3.3 3.4-1.2 0-2.2-.6-3.2-.6s-2 .6-3.2.6c-1.8 0-3.3-1.4-3.3-3.4 0-2.9 3.1-5.6 6.5-5.6z"/></svg>',
    stern: '<svg viewBox="0 0 24 24"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.5L12 17.3l-5.9 3.2 1.3-6.5L2.5 9.4l6.6-.8L12 2.5z"/></svg>'
  };
  var GP_GOLD = '#C9A44C';

  function initGprev(root) {
    if (root.dataset.gprevReady) return;
    root.dataset.gprevReady = '1';

    var designMode = root.dataset.designMode === 'true';
    var openBtn = root.querySelector('[data-gprev-open]');
    var modal = root.querySelector('[data-gprev-modal]');
    var dialog = modal.querySelector('.gprev-dialog');
    var stage = modal.querySelector('[data-gprev-stage]');
    var textEl = modal.querySelector('[data-gprev-text]');
    var l1 = modal.querySelector('[data-gprev-line1]');
    var l2 = modal.querySelector('[data-gprev-line2]');
    var emptyEl = modal.querySelector('[data-gprev-empty]');
    var jumpBtn = modal.querySelector('[data-gprev-jump]');
    var lastFocus = null;

    var fonts = [];
    try {
      fonts = JSON.parse(root.querySelector('[data-gprev-fonts]').textContent) || [];
    } catch (e) { /* keine Blöcke angelegt */ }

    var trackedUsed = false;
    function track(evt) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: evt });
    }

    /* ── Produktformular / Suchbereich ── */
    var productForm = null;
    Array.prototype.some.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      if (f.querySelector('[name="id"]')) { productForm = f; return true; }
    });
    var scope = productForm
      ? (productForm.closest('section') || productForm.closest('.shopify-section') || document.body)
      : document.body;

    /* ── Feld-Erkennung (Settings-Selektor vor Auto-Erkennung) ── */
    function bySetting(attr) {
      var sel = (root.dataset[attr] || '').trim();
      if (!sel) return null;
      try { return scope.querySelector(sel) || document.querySelector(sel); }
      catch (e) { return null; }
    }

    function labelMatches(el, rx) {
      var texts = [];
      if (el.labels && el.labels.length) {
        Array.prototype.forEach.call(el.labels, function (l) { texts.push(l.textContent); });
      }
      texts.push(el.getAttribute('aria-label') || '');
      texts.push(el.getAttribute('placeholder') || '');
      texts.push(el.getAttribute('name') || '');
      var box = el.closest('div, fieldset');
      if (box) {
        var h = box.querySelector('label, legend, h1,h2,h3,h4,h5,p,span');
        if (h) texts.push(h.textContent);
      }
      return rx.test(texts.join(' '));
    }

    function findTextInputs() {
      var explicit1 = bySetting('selName1');
      var explicit2 = bySetting('selName2');
      if (explicit1) return [explicit1, explicit2].filter(Boolean);
      var candidates = Array.prototype.filter.call(
        scope.querySelectorAll('input[type="text"], input:not([type])'),
        function (i) {
          if (root.contains(i)) return false;
          return labelMatches(i, /name|zeile/i);
        }
      );
      return candidates.slice(0, 2);
    }

    function findFontControl() {
      var explicit = bySetting('selFont');
      if (explicit) return explicit;
      var sel = Array.prototype.filter.call(
        scope.querySelectorAll('select'),
        function (s) { return labelMatches(s, /schrift/i); }
      );
      return sel[0] || null;
    }

    function findGroup(rx, settingAttr) {
      var explicit = bySetting(settingAttr);
      if (explicit) return explicit;
      var heads = Array.prototype.filter.call(
        scope.querySelectorAll('label, legend, h1,h2,h3,h4,h5,p,span'),
        function (el) {
          return rx.test(el.textContent || '') && (el.textContent || '').length < 60;
        }
      );
      for (var i = 0; i < heads.length; i++) {
        var box = heads[i].closest('div, fieldset');
        while (box && box !== scope) {
          if (box.querySelector('input[type="radio"], input[type="checkbox"]')) return box;
          box = box.parentElement;
        }
      }
      return null;
    }

    function sampleColor(group) {
      if (!group) return null;
      var checked = group.querySelector('input:checked');
      if (!checked) return null;
      var probe = checked.closest('label') || checked.parentElement;
      var els = [probe].concat(Array.prototype.slice.call(probe ? probe.querySelectorAll('*') : []));
      for (var i = 0; i < els.length; i++) {
        if (!els[i]) continue;
        var bg = window.getComputedStyle(els[i]).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent' &&
            bg !== 'rgb(255, 255, 255)') return bg;
      }
      for (var j = 0; j < els.length; j++) {
        if (!els[j]) continue;
        var bg2 = window.getComputedStyle(els[j]).backgroundColor;
        if (bg2 && bg2 !== 'rgba(0, 0, 0, 0)' && bg2 !== 'transparent') return bg2;
      }
      return null;
    }

    function readSymbol(group) {
      if (!group) return null;
      var checked = group.querySelector('input:checked');
      if (!checked) return null;
      var raw = (checked.value || '') + ' ';
      var lbl = checked.closest('label');
      if (lbl) {
        raw += lbl.textContent + ' ';
        var img = lbl.querySelector('img');
        if (img) raw += (img.alt || '') + ' ' + (img.src || '');
      }
      raw = raw.toLowerCase();
      var key = null;
      if (/herz|heart/.test(raw)) key = 'herz';
      else if (/krone|crown/.test(raw)) key = 'krone';
      else if (/pfote|paw/.test(raw)) key = 'pfote';
      else if (/stern|star/.test(raw)) key = 'stern';
      if (!key) return null;
      return { key: key, gold: /gold/.test(raw) };
    }

    function resolveFont(labelText) {
      if (!labelText || !fonts.length) return fonts[0] || null;
      var t = labelText.toLowerCase();
      for (var i = 0; i < fonts.length; i++) {
        if (fonts[i].match && t.indexOf(fonts[i].match) !== -1) return fonts[i];
      }
      return fonts[0] || null;
    }

    /* ── Schriftgröße relativ zur Bildbreite ── */
    function applySize() {
      var w = stage.clientWidth || 520;
      var size = parseFloat(getComputedStyle(root).getPropertyValue('--gp-size')) || 8;
      textEl.style.fontSize = (w * size / 100) + 'px';
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(applySize).observe(stage);
    } else {
      window.addEventListener('resize', applySize);
    }

    /* ── Vorschau-Inhalt aktualisieren ── */
    function refresh() {
      var inputs = findTextInputs();
      var name1 = inputs[0] ? inputs[0].value.trim() : '';
      var name2 = inputs[1] ? inputs[1].value.trim() : '';

      /* Button dezent aktivieren, sobald getippt wurde */
      openBtn.classList.toggle('is-live', !!name1);
      if (name1 && !trackedUsed) {
        trackedUsed = true;
        track('perso_preview_used');
      }

      if (designMode && !name1) name1 = 'Emilia';

      if (!name1) {
        emptyEl.hidden = false;
        textEl.style.visibility = 'hidden';
        return;
      }
      emptyEl.hidden = true;
      textEl.style.visibility = 'visible';
      applySize();

      /* Schrift */
      var fontCtl = findFontControl();
      var fontLabel = '';
      if (fontCtl && fontCtl.tagName === 'SELECT' && fontCtl.selectedIndex >= 0) {
        fontLabel = fontCtl.options[fontCtl.selectedIndex].textContent || '';
      }
      var font = resolveFont(fontLabel);
      if (font) {
        textEl.style.fontFamily = '"' + font.family + '", cursive';
        textEl.style.fontStyle = font.style || 'normal';
        textEl.style.fontWeight = font.weight || '400';
      } else {
        textEl.style.fontFamily = 'cursive';
      }

      /* Garnfarbe */
      var colorGroup = findGroup(/garnfarbe|farbe/i, 'selColor');
      var thread = sampleColor(colorGroup);
      if (thread) root.style.setProperty('--gp-thread', thread);

      /* Symbol (an Zeile 1) */
      var symGroup = findGroup(/symbol/i, 'selSymbol');
      var sym = readSymbol(symGroup);
      var symHtml = '';
      if (sym && GP_SYMBOLS[sym.key]) {
        symHtml = '<span class="gprev-symbol"' +
          (sym.gold ? ' style="color:' + GP_GOLD + '"' : '') +
          '>' + GP_SYMBOLS[sym.key] + '</span>';
      }

      l1.innerHTML = '';
      l1.appendChild(document.createTextNode(name1));
      if (symHtml) l1.insertAdjacentHTML('beforeend', symHtml);

      if (name2) {
        l2.hidden = false;
        l2.textContent = name2;
      } else {
        l2.hidden = true;
      }
    }

    /* ── Overlay öffnen / schließen ── */
    function openModal() {
      lastFocus = document.activeElement;
      refresh();
      modal.hidden = false;
      /* reflow, damit die Einblend-Transition greift */
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.body.classList.add('gprev-lock');
      modal.querySelector('[data-gprev-close]').focus();
      applySize();
      track('perso_preview_open');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('gprev-lock');
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', openModal);
    modal.querySelector('[data-gprev-close]').addEventListener('click', closeModal);
    modal.querySelector('[data-gprev-close-area]').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (jumpBtn) {
      jumpBtn.addEventListener('click', function () {
        closeModal();
        var inputs = findTextInputs();
        if (inputs[0]) {
          inputs[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { inputs[0].focus(); }, 350);
        }
      });
    }

    /* ── Eingaben der App live verfolgen ── */
    ['input', 'change', 'click'].forEach(function (evt) {
      scope.addEventListener(evt, function (e) {
        if (root.contains(e.target)) return;
        window.requestAnimationFrame(refresh);
      }, true);
    });
    var mo = new MutationObserver(function () {
      window.requestAnimationFrame(refresh);
    });
    mo.observe(scope, { childList: true, subtree: true });

    /* ── Button unter den Warenkorb-Button hängen,
       Overlay ans body-Ende (gegen Stacking-Kontexte) ── */
    document.body.appendChild(modal);
    if (productForm) {
      var submit = productForm.querySelector('[type="submit"]');
      try {
        if (submit) {
          /* direkt unter dem Warenkorb-Button, gleiche Breite */
          submit.insertAdjacentElement('afterend', openBtn);
        } else {
          productForm.insertAdjacentElement('afterend', openBtn);
        }
      } catch (e) { /* Button bleibt an Section-Position */ }
    }

    /* Im Theme-Editor: Overlay beim Auswählen der Section öffnen */
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains && e.target.querySelector('#' + root.id)) {
          openModal();
        }
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('.gprev').forEach(initGprev);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
